import React from 'react';
import { StyleSheet } from 'react-native';
import Text from 'design-system/Text';
import { rem } from 'design-system/values';
import { Spacer } from 'design-system';
import IconArrowTriangle from 'design-system/icons/IconArrowTriangle';
import useColors from 'hooks/useColors';
import TouchableOpacity from 'utils/packages/TouchableOpacity';
const arrowSize = rem(8);
const ChipBase = ({ onPress, style, disabled, toolTip, compact, children }) => {
    const colors = useColors();
    return (<TouchableOpacity style={[
            styles.chip,
            compact ? styles.compact : undefined,
            {
                backgroundColor: colors.cards.onDark,
            },
            style,
        ]} onPress={onPress} disabled={disabled} hoverOnDark>
      {children}
      {toolTip ? (<>
          <Spacer w={8}/>
          {toolTip}
        </>) : null}
      {!compact && !disabled ? (<IconArrowTriangle width={arrowSize} height={arrowSize} style={styles.arrowIcon} color={colors.elements.secondary}/>) : null}
    </TouchableOpacity>);
};
export const TextChip = ({ text, ...props }) => (<ChipBase {...props} compact={false}>
    <Text Text-14 Secondary>
      {text}
    </Text>
  </ChipBase>);
export const IconChip = ({ children: icon, ...props }) => (<ChipBase {...props} compact>
    {icon}
  </ChipBase>);
const styles = StyleSheet.create({
    chip: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: rem(8),
        paddingHorizontal: rem(16),
        paddingVertical: rem(6),
        minHeight: rem(31),
        marginRight: rem(12),
    },
    compact: {
        paddingHorizontal: rem(6),
    },
    arrowIcon: {
        marginLeft: rem(8),
    },
});
